/* eslint-disable react/jsx-key */
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { Marker } from 'react-google-maps';

import { SYMBOL_TYPES, MARKER_STYLES } from 'shared/constants/map';
import { getSymbolUrl } from 'shared/helpers/map';
import { MapInfoWindow, Symbol } from 'shared/components/presentational/Map';
import { COLORS } from 'shared/constants/theme';
import { HOME_STATES } from '../constants';

const StyledMapInfoWindow = styled(MapInfoWindow)`
  max-width: 300px;
`;

const stateToColor = state => {
  switch (state) {
    case HOME_STATES.CONNECTED:
      return COLORS.mantisGreen;
    case HOME_STATES.PENDING:
      return COLORS.dodgerBlue;
    default:
      return COLORS.valencia;
  }
};

export default class MapHomeMarkers extends PureComponent {
  renderAddress = ({ number, numberExtra, roadType, roadName, city }) => (
    <Fragment>
      {`${number} ${numberExtra || ''} ${roadType} ${roadName}, ${city}`}
    </Fragment>
  );

  renderInfo = ({ state }, t) => {
    switch (state) {
      case HOME_STATES.CONNECTED:
        return (
          <Fragment>
            <p>{t('blocks.map.homeStatesConnected.label')}</p>
            <p>{t('blocks.map.homeStatesConnected.description')}</p>
          </Fragment>
        );
      case HOME_STATES.PENDING:
        return (
          <Fragment>
            <p>{t('blocks.map.homeStatesPending.label')}</p>
            <p>{t('blocks.map.homeStatesPending.description')}</p>
          </Fragment>
        );
      default:
        return (
          <Fragment>
            <p>{t('blocks.map.homeStatesDefault.label')}</p>
            <p>{t('blocks.map.homeStatesDefault.description')}</p>
          </Fragment>
        );
    }
  };

  render() {
    const {
      homes = [],
      selectedHome,
      onMarkerClick: handleMarkerClick,
      onInfoWindowClose: handleInfoWindowClose,
      t
    } = this.props;

    const { renderAddress, renderInfo } = this;

    return homes.map(home => (
      <Marker
        key={home.id}
        noRedraw
        icon={{
          ...MARKER_STYLES,
          url: getSymbolUrl('', stateToColor(home.state))
        }}
        position={home.position}
        onClick={() => handleMarkerClick(home)}
      >
        {selectedHome && selectedHome.id === home.id && (
          <StyledMapInfoWindow
            onCloseClick={handleInfoWindowClose}
            isLoading={false}
          >
            <MapInfoWindow.children.Header>
              <Symbol type={SYMBOL_TYPES.HOME} height="32px" width="32px" />
            </MapInfoWindow.children.Header>
            <MapInfoWindow.children.ContentSection>
              {renderAddress(home.address)}
            </MapInfoWindow.children.ContentSection>
            <MapInfoWindow.children.ContentSection>
              {renderInfo(home, t)}
            </MapInfoWindow.children.ContentSection>
          </StyledMapInfoWindow>
        )}
      </Marker>
    ));
  }
}
